import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import SwiperClass from 'swiper';

import { styled } from '@mui/material';

import { ArrowLeftIcon, ArrowRightIcon } from '../../../../assets/icons';
import FadeText from '../../text/fade-text';
import cssVars from './../../../styles/export-variables.module.scss';
import { Variant } from './product-card-color-slider';
import styles from './product-card-color-slider.module.scss';

export const ColorVariantsSlider = ({
  variants,
  selectedIndex,
  setSelectedIndex,
}: {
  variants: Variant[];
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
}) => {
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);

  const swiperSpeed: number = React.useMemo(
    () => parseInt(cssVars.transitionDuration),
    [],
  );
  const slidesPerView = 3;

  const showArrows = variants.length > 2;

  return (
    variants.length >= 2 && (
      <>
        {showArrows && (
          <PrevButton
            className={styles.onCardHover}
            onClick={() => {
              swiper?.slidePrev();
            }}
          >
            <ArrowLeftIcon className={styles.navIcons} />
          </PrevButton>
        )}
        <StyledSwiper
          slidesPerView={slidesPerView}
          onSwiper={setSwiper}
          speed={swiperSpeed}
          initialSlide={selectedIndex}
          centeredSlides
          allowTouchMove={false}
          onClick={(swiper) => {
            if (swiper.clickedIndex !== swiper.activeIndex) {
              if (swiper.clickedIndex === swiper.activeIndex - 1) {
                swiper.slidePrev();
              } else {
                swiper.slideNext();
              }
            }
          }}
          onSlideChange={(swiper) => setSelectedIndex(swiper.realIndex)}
          className={`${styles.onCardHover}`}
        >
          {variants.map((v, i) => (
            <SwiperSlide key={i}>
              <ImageContainer>{v.image}</ImageContainer>
            </SwiperSlide>
          ))}
        </StyledSwiper>
        {showArrows && (
          <NextButton
            className={styles.onCardHover}
            onClick={() => {
              swiper?.slideNext();
            }}
          >
            <ArrowRightIcon className={styles.navIcons} />
          </NextButton>
        )}
        <ColorLabel className={styles.onCardHover}>
          <ColorName
            text={variants[selectedIndex % variants.length]?.colorName || ''}
          />
        </ColorLabel>
      </>
    )
  );
};

const StyledSwiper = styled(Swiper)(({ theme }) => ({
  gridArea: 'thumb',
  cursor: 'pointer',
  display: 'inline-grid',
  width: '100%',

  '& .swiper-wrapper': {
    alignItems: 'center',
  },
}));

const getTransition = (property: string, delay = 0) => ({
  transitionDuration: 'var(--transition-duration)',
  transitionProperty: property,
  transitionTimingFunction: 'var(--transition-timing)',
  transitionDelay: delay,
});

const ImageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',

  '& .gatsby-image-wrapper, img': {
    ...getTransition('opacity'),
    width: '100%',
    objectFit: 'contain',
    padding: '5%',

    '&:hover': {
      opacity: 0.7,
    },

    '& img': {
      margin: '7.5px',
      aspectRatio: 1,
      height: 'auto',
      width: 'calc(100% - 20px)',
    },
  },
}));

const ColorLabel = styled('div')({
  gridArea: 'color',
  margin: 0,
});

const buttonStyles = {
  border: 'none',
  backgroundColor: 'transparent',
  webkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
};

const NextButton = styled('button')({
  gridArea: 'next',
  ...buttonStyles,
});

const PrevButton = styled('button')({
  gridArea: 'prev',
  ...buttonStyles,
});

const ColorName = styled(FadeText)(({ theme }) => ({
  ...theme.typography.footnote,
  fontWeight: theme.typography.fontWeightRegular,
  color: 'var(--color-medium-grey)',
  textAlign: 'center',
  margin: '0',
}));
